import {Subscriptions} from './Subscriptions';

export const VirtualMoney = () => {
  return <Subscriptions type="VIRTUALMONEY" />;
};
